import { getModule, Mutation, VuexModule, Module } from 'vuex-module-decorators';
import store from '@/store/index';
import { PermissionType } from '@/auth/permission';

@Module({
  namespaced: true,
  name: 'authMod',
  dynamic: true,
  store
})
export default class AuthModule extends VuexModule {
  private authAccessToken = '';
  private permissions: PermissionType[] = [];

  get getAuthAccessToken(): string {
    return this.authAccessToken;
  }

  get getPermissions(): PermissionType[] {
    return this.permissions;
  }

  @Mutation
  setAuthAccessToken(authAccessToken: string): void {
    this.authAccessToken = authAccessToken;
  }

  @Mutation
  setPermissions(permissions: PermissionType[]): void {
    this.permissions = permissions;
  }
}

export const authMod = getModule(AuthModule);
